export const API_PATHS = {
  // Dashboard
  DASHBOARD_COUNTS: '/admin/dashboard-counts',
  DASHBOARD_REVENUE_DAY: '/admin/dashboard-revenue-day',
  DASHBOARD_ACTIVE_PATIENTS: '/admin/dashboard-active-patients',
  DASHBOARD_BIRTHDAY: '/admin/dashboard-upcoming-birthday',
  DASHBOARD_OVERVIEW_GRAPH: '/admin/dashboard-overview-graph',
  DASHBOARD_MEMBERS_GRAPH: '/admin/dashboard-members-graph',

  // Patient
  PATIENT_LIST: '/admin/patient/list',
  PATIENT_ADD: '/admin/patient/add',
  PATIENT_DETAILS: '/admin/patient/details',
  PATIENT_PAYMENT_HISTORY: '/admin/patient-payment-history',
  PATIENT_SESSION: '/admin/patient-session',
  PATIENT_DEACTIVATE: '/admin/patient/deactivate',
  PATIENT_PREVIEW_CSV: '/admin/patient/preview-csv',
  PATIENT_IMPORT_CSV: '/admin/patient/import-csv',

  // Prescriptions
  PRESCRIPTION_UPLOAD: '/admin/prescription/upload',
  PRESCRIPTION_LIST: '/admin/prescription/list',
  PRESCRIPTION_DELETE: '/admin/prescription/delete',

  // Staff / Employee
  STAFF_LIST: '/admin/staff/list',
  STAFF_LOGIN_OVERVIEW: '/admin/users/login-overview',
  STAFF_MEMBER_PERMISSIONS: '/admin/users/member/permissions',
  STAFF_MEMBER_PASSWORD: '/admin/users/member/password',
  STAFF_MEMBER_EMAIL: '/admin/users/member/email',
  STAFF_MEMBER_STATUS: '/admin/users/member/status',
  STAFF_MEMBER_DELETE: '/admin/users/member/delete',
  STAFF_MEMBER_UPCOMING_SESSIONS: '/admin/users/member/upcoming-sessions',
  STAFF_MEMBER_REASSIGN_SESSIONS: '/admin/users/member/reassign-sessions',
  STAFF_ADD: '/admin/staff/add',
  STAFF_DETAILS: '/admin/staff/details',
  STAFF_UPDATE_PROFILE_IMAGE: '/admin/staff/update-profile-image',
  STAFF_ADD_SALARY: '/admin/staff/addSalary',
  STAFF_SALARY_LIST: '/admin/staff-salary-list',
  STAFF_ATTENDANCE_LIST: '/admin/staff/attendance-list',
  STAFF_SESSION: '/admin/staff-session',
  STAFF_ACTIVITY_SUMMARY: '/admin/staff-activity-summary',
  STAFF_ATTENDANCE_SUMMARY: '/admin/staff-attendance-summary',

  // Member Session Rates
  MEMBER_SESSION_RATES_LIST: '/admin/member-session-rates/list',
  MEMBER_SESSION_RATES_SAVE: '/admin/member-session-rates/save',
  MEMBER_SESSION_RATES_UPDATE: '/admin/member-session-rates/update',
  MEMBER_SESSION_RATES_DELETE: '/admin/member-session-rates/delete',
  MEMBER_SERVICE_OVERRIDES_LIST: '/admin/member-session-rates/service-overrides/list',
  MEMBER_SERVICE_OVERRIDES_SAVE: '/admin/member-session-rates/service-overrides/save',
  MEMBER_SERVICE_OVERRIDES_ASSIGN: '/admin/member-session-rates/service-overrides/assign',
  MEMBER_SERVICE_OVERRIDES_PEERS: '/admin/member-session-rates/service-overrides/peers',

  // Attendance
  STAFF_ATTENDANCE: '/admin/staff-attendance',
  STAFF_ATTENDANCE_UNMARK: '/admin/staff-attendance/unmark',
  STAFF_ATTENDANCE_REQUEST_APPROVE: '/admin/staff-attendance/requests/approve',
  STAFF_ATTENDANCE_REQUEST_REJECT: '/admin/staff-attendance/requests/reject',

  // Appointment
  APPOINTMENT: '/admin/appointment',
  APPOINTMENT_ADD: '/admin/appointment/add',
  APPOINTMENT_MARK_STATUS: '/admin/mark-absent-present-for-appointment',
  APPOINTMENT_CANCEL: '/admin/appointment/cancel',
  APPOINTMENT_CANCEL_CHECK: '/admin/appointment/cancel/check',
  APPOINTMENT_CANCEL_SERIES_CHECK: '/admin/appointment/cancel-series/check',
  APPOINTMENT_CANCEL_SERIES: '/admin/appointment/cancel-series',
  PATIENT_OLD_DUES: '/admin/patient/old-dues',
  APPOINTMENT_CHECK_CONFLICTS: '/admin/appointment/check-conflicts',
  APPOINTMENT_AVAILABLE_SLOTS: '/admin/appointment/available-slots',
  APPOINTMENT_PREVIEW_FEE: '/admin/appointment/preview-fee',
  APPOINTMENT_TRANSITION: '/admin/appointment/transition',
  APPOINTMENT_THERAPIST_SCHEDULES: '/admin/appointment/therapist-schedules',
  APPOINTMENT_THERAPIST_SCHEDULES_UPDATE: '/admin/appointment/therapist-schedules/update',
  APPOINTMENT_UPDATE_NOTES: '/admin/appointment/update-notes',
  APPOINTMENT_UPDATE_DATE: '/admin/appointment/update-date',
  APPOINTMENT_RESCHEDULE: '/admin/appointment/reschedule',
  APPOINTMENT_GUEST_BOOK: '/admin/appointment/guest/book',
  APPOINTMENT_GUEST_LIST: '/admin/appointment/guest/list',
  APPOINTMENT_GUEST_LOOKUP: '/admin/appointment/guest/lookup',
  APPOINTMENT_RESCHEDULE_RATE_CHECK: '/admin/appointment/reschedule/rate-check',
  // Change a series' therapy from a date: preview (check), then commit with its fingerprint.
  APPOINTMENT_CHANGE_THERAPY_CHECK: '/admin/appointment/change-therapy/check',
  APPOINTMENT_CHANGE_THERAPY: '/admin/appointment/change-therapy',
  APPOINTMENT_CHANGE_SESSION_TYPE_CHECK: '/admin/appointment/change-session-type/check',
  APPOINTMENT_CHANGE_SESSION_TYPE: '/admin/appointment/change-session-type',
  APPOINTMENT_BULK_DELETE_PREVIEW: '/admin/appointment/bulk-delete-preview',
  APPOINTMENT_DELETE_BY_MONTH: '/admin/appointment/delete-by-month',
  // Google Meet on one appointment. The backend makes, changes and removes the Google event;
  // `get` takes { appointment_ids: [..] }, the others { appointment_id }.
  APPOINTMENT_GOOGLE_MEET: '/admin/appointment/google-meet/get',
  APPOINTMENT_GOOGLE_MEET_ENABLE: '/admin/appointment/google-meet/enable',
  APPOINTMENT_GOOGLE_MEET_DISABLE: '/admin/appointment/google-meet/disable',
  APPOINTMENT_GOOGLE_MEET_RETRY: '/admin/appointment/google-meet/retry',

  // Income
  INCOME_LIST: '/admin/income/list',
  INCOME_ADD: '/admin/income/add',
  INCOME_UPDATE: '/admin/income/update',
  INCOME_DELETE: '/admin/income/delete',

  // Expense
  EXPENSE_LIST: '/admin/expense/list',
  EXPENSE_ADD: '/admin/expense/add',
  EXPENSE_UPDATE: '/admin/expense/update',
  EXPENSE_DELETE: '/admin/expense/delete',

  // Invoice
  INVOICE_LIST: '/admin/invoice/list',
  INVOICE_PAYMENT_HISTORY: '/admin/invoice-payment-history',

  // Payment
  SESSION_DISCOUNT_ADD_REMOVE: '/admin/added-session-discount-add-remove',
  ADD_INVOICE_PAYMENT: '/admin/add-invoice-payment',
  ADD_COMBINED_INVOICE_PAYMENT: '/admin/add-combined-invoice-payment',
  REFUND_INVOICE_PAYMENT: '/admin/refund-invoice-payment',

  // Dashboard — Patient Fees
  DASHBOARD_UNPAID_FEES: '/admin/dashboard/unpaid-fees',

  // Analytics & Smart Insights
  DASHBOARD_INSIGHTS: '/admin/dashboard/insights',
  ANALYTICS_PRICING: '/admin/analytics/pricing-insights',
  INVOICES_OVERDUE: '/admin/invoices/overdue',

  // Predictive Intelligence (Phase 3)
  PREDICTIVE_DROPOUT_RISK: '/admin/predictive/dropout-risk',
  PREDICTIVE_DROPOUT_RISK_SINGLE: '/admin/predictive/dropout-risk/patient',
  PREDICTIVE_REVENUE_FORECAST: '/admin/predictive/revenue-forecast',
  PREDICTIVE_REVENUE_FORECAST_EXTENDED: '/admin/predictive/revenue-forecast-extended',
  PREDICTIVE_THERAPIST_PERFORMANCE: '/admin/predictive/therapist-performance',
  PREDICTIVE_BUSINESS_ADVISOR: '/admin/predictive/business-advisor',
  PREDICTIVE_DATA_HEALTH: '/admin/predictive/data-health',

  // Clinical Intelligence (Phase 4)
  CLINICAL_PROGRESS: '/admin/clinical/progress',
  CLINICAL_PROGRESS_SINGLE: '/admin/clinical/progress/patient',
  CLINICAL_THERAPY_EFFECTIVENESS: '/admin/clinical/therapy-effectiveness',
  CLINICAL_GOALS: '/admin/clinical/goals',
  CLINICAL_GOALS_SINGLE: '/admin/clinical/goals/patient',
  CLINICAL_STAGNATION: '/admin/clinical/stagnation',
  CLINICAL_RECOMMENDATIONS: '/admin/clinical/recommendations',
  CLINICAL_RECOMMENDATIONS_SINGLE: '/admin/clinical/recommendations/patient',

  // Role Management
  ROLE_LIST: '/admin/role/list',
  ROLE_ADD: '/admin/role/add',
  ROLE_DELETE: '/admin/role/delete',
  ROLE_RESET_PERMISSIONS: '/admin/role/resetPermissions',
  ROLE_LIST_DROPDOWN: '/admin/role/listDropdown',
  PERMISSION_LIST: '/admin/permission',

  // SaaS Management (Phase 5)
  SAAS_CLINICS: '/admin/saas/clinics',
  SAAS_CLINIC_DETAILS: '/admin/saas/clinic/details',
  SAAS_CLINIC_CREATE: '/admin/saas/clinic/create',
  SAAS_CLINIC_STATUS: '/admin/saas/clinic/status',
  SAAS_CLINIC_IMPERSONATE: '/admin/saas/clinic/impersonate',
  SAAS_CLINIC_MEMBER_PASSWORD: '/admin/saas/clinic/member/password',
  SAAS_CLINIC_MEMBER_EMAIL: '/admin/saas/clinic/member/email',
  SAAS_CLINIC_MEMBER_STATUS: '/admin/saas/clinic/member/status',
  SAAS_CLINIC_MEMBER_DELETE: '/admin/saas/clinic/member/delete',
  SAAS_PLANS: '/admin/saas/plans',
  SAAS_PLAN_CREATE: '/admin/saas/plan/create',
  SAAS_PLAN_UPDATE: '/admin/saas/plan/update',
  SAAS_SUBSCRIPTIONS: '/admin/saas/subscriptions',
  SAAS_SUBSCRIPTION_ASSIGN: '/admin/saas/subscription/assign',
  SAAS_ANALYTICS: '/admin/saas/analytics',
  SAAS_ONBOARDING: '/admin/saas/onboarding',
  SAAS_ACTIVITY_LOGS: '/admin/saas/activity-logs',
  SAAS_USAGE_STATS: '/admin/saas/usage-stats',
  SAAS_PAYMENT_FAILURES: '/admin/saas/payment-failures',
  SAAS_BRANDING: '/admin/saas/branding',
  SAAS_BRANDING_UPDATE: '/admin/saas/branding/update',

  // Cross-Branch Intelligence (Phase 5)
  CROSS_BRANCH_COMPARISON: '/admin/saas/cross-branch/comparison',
  CROSS_BRANCH_REVENUE: '/admin/saas/cross-branch/revenue',
  CROSS_BRANCH_PERFORMANCE: '/admin/saas/cross-branch/performance',

  // Marketing Content — Newsletter & Testimonials
  NEWSLETTER_SUBSCRIBERS: '/admin/content/newsletter-subscribers',
  TESTIMONIALS_LIST: '/admin/content/testimonials',
  TESTIMONIALS_CREATE: '/admin/content/testimonials/create',
  TESTIMONIALS_UPDATE: '/admin/content/testimonials/update',
  TESTIMONIALS_DELETE: '/admin/content/testimonials/delete',

  // Payment Gateway (Phase 6)
  SAAS_PAYMENT_CREATE_ORDER: '/admin/saas/payment/create-order',
  SAAS_PAYMENT_VERIFY: '/admin/saas/payment/verify',
  SAAS_PAYMENT_HISTORY: '/admin/saas/payment/history',

  // Services Management
  SERVICES_LIST: '/admin/services',
  SERVICES_CREATE: '/admin/services/create',
  SERVICES_UPDATE: '/admin/services/update',
  SERVICES_DELETE: '/admin/services/delete',
  SERVICES_TOGGLE: '/admin/services/toggle',
  SERVICES_DUPLICATE: '/admin/services/duplicate',
  SERVICES_CLINIC_TYPE: '/admin/services/clinic-type',
  SERVICES_CLINIC_TYPE_UPDATE: '/admin/services/clinic-type/update',
  SERVICES_REPLACE: '/admin/services/replace',
  SERVICES_CATALOG: '/admin/services/catalog',
  SERVICES_IMPORT_DEFAULTS: '/admin/services/import-defaults',
  SERVICES_SESSION_PRICES: '/admin/services/session-prices',
  SERVICES_SESSION_PRICES_SAVE: '/admin/services/session-prices/save',
  SERVICES_STAFF_PRICES: '/admin/services/staff-prices',

  // Rooms Management
  ROOMS_LIST: '/admin/rooms',
  ROOMS_CREATE: '/admin/rooms/create',
  ROOMS_UPDATE: '/admin/rooms/update',
  ROOMS_DELETE: '/admin/rooms/delete',
  ROOMS_TOGGLE: '/admin/rooms/toggle',

  // Referrers — who sent a patient (BR-PAT-4)
  REFERRERS_LIST: '/admin/referrers',
  REFERRERS_CREATE: '/admin/referrers/create',
  REFERRERS_UPDATE: '/admin/referrers/update',
  REFERRERS_MERGE: '/admin/referrers/merge',
  REFERRERS_REPORT: '/admin/referrers/report',
  REFERRERS_PATIENTS: '/admin/referrers/patients',

  // Session Types Management
  SESSION_TYPES_LIST: '/admin/session-types',
  SESSION_TYPES_CREATE: '/admin/session-types/create',
  SESSION_TYPES_UPDATE: '/admin/session-types/update',
  SESSION_TYPES_DELETE: '/admin/session-types/delete',
  SESSION_TYPES_TOGGLE: '/admin/session-types/toggle',
  SESSION_TYPES_USAGE: '/admin/session-types/usage',
  SESSION_TYPE_SERVICE_QUOTAS: '/admin/session-types/service-quotas',
  SESSION_TYPE_SERVICE_QUOTAS_SAVE: '/admin/session-types/service-quotas/save',
  SESSION_TYPES_GROUP_DAY_CHECK: '/admin/session-types/group-day/check',
  SESSION_TYPES_GROUP_DAY_CHANGE: '/admin/session-types/group-day/change',
  SESSION_TYPES_REPRICE_CHECK: '/admin/session-types/reprice/check',
  SESSION_TYPES_REPRICE_APPLY: '/admin/session-types/reprice/apply',

  // Designations Management
  DESIGNATIONS_LIST: '/admin/designations',
  DESIGNATIONS_CREATE: '/admin/designations/create',
  DESIGNATIONS_UPDATE: '/admin/designations/update',
  DESIGNATIONS_DELETE: '/admin/designations/delete',
  DESIGNATIONS_TOGGLE: '/admin/designations/toggle',
  DESIGNATIONS_DROPDOWN: '/admin/designations/dropdown',
  DESIGNATIONS_SERVICES: '/admin/designations/services',
  DESIGNATIONS_SERVICES_SET: '/admin/designations/services/set',

  // Revenue by Service Analytics
  ANALYTICS_REVENUE_BY_SERVICE: '/admin/analytics/revenue-by-service',

  // Clinic Settings
  SETTINGS_GET: '/admin/settings/get',
  SETTINGS_UPDATE: '/admin/settings/update',
  SETTINGS_CLINIC_DETAILS: '/admin/settings/clinic/details',
  SETTINGS_CLINIC_UPDATE: '/admin/settings/clinic/update',

  // Google Calendar & Meet — the clinic's one company Google account. The OAuth callback
  // (/admin/settings/integrations/google/callback) is reached by Google's redirect, never called.
  GOOGLE_INTEGRATION_STATUS: '/admin/settings/integrations/google/status',
  GOOGLE_INTEGRATION_CONNECT: '/admin/settings/integrations/google/connect',
  GOOGLE_INTEGRATION_DISCONNECT: '/admin/settings/integrations/google/disconnect',

  // Waiting List
  WAITING_LIST: '/admin/waiting-list',
  WAITING_LIST_ADD: '/admin/waiting-list/add',
  WAITING_LIST_UPDATE: '/admin/waiting-list/update',
  WAITING_LIST_ASSIGN: '/admin/waiting-list/assign',
  WAITING_LIST_CANCEL: '/admin/waiting-list/cancel',
  WAITING_LIST_MATCHING: '/admin/waiting-list/matching',
  WAITING_LIST_PATIENT: '/admin/waiting-list/patient',
  WAITING_LIST_UNASSIGNED_PATIENTS: '/admin/waiting-list/unassigned-patients',

  // Support Tickets
  SUPPORT_CREATE: '/admin/support/create',
  SUPPORT_LIST: '/admin/support/list',
  SUPPORT_REPLY: '/admin/support/reply',
  SUPPORT_STATUS: '/admin/support/status',

  // Payment Reminders
  PAYMENT_REMINDERS_LIST: '/admin/payment-reminders',
  PAYMENT_REMINDERS_SEND_EMAIL: '/admin/payment-reminders/send-email',

  // Patient Billing Engine (Phase 7)
  BILLING_PLANS_LIST: '/admin/billing/plans/list',
  BILLING_PLANS_GET: '/admin/billing/plans/get',
  BILLING_PLANS_CREATE: '/admin/billing/plans/create',
  BILLING_PLANS_UPDATE: '/admin/billing/plans/update',
  BILLING_PLANS_TOGGLE: '/admin/billing/plans/toggle',
  BILLING_PATIENT_PLAN_ASSIGN: '/admin/billing/patient-plan/assign',
  BILLING_PATIENT_PLAN_CLOSE: '/admin/billing/patient-plan/close',
  BILLING_PATIENT_PLAN_GET: '/admin/billing/patient-plan/get',
  BILLING_PATIENT_PLAN_LIST: '/admin/billing/patient-plan/list',
  BILLING_ATTENDANCE_MARK: '/admin/billing/attendance/mark',
  BILLING_ATTENDANCE_BULK_MARK: '/admin/billing/attendance/bulk-mark',
  BILLING_ATTENDANCE_CENTRE_OFF: '/admin/billing/attendance/centre-off',
  BILLING_ATTENDANCE_UNMARKED: '/admin/billing/attendance/unmarked',
  BILLING_ATTENDANCE_LIST: '/admin/billing/attendance/list',
  BILLING_WALLET_BALANCE: '/admin/billing/wallet/balance',
  BILLING_WALLET_ADD_PAYMENT: '/admin/billing/wallet/add-payment',
  BILLING_WALLET_REFUND: '/admin/billing/wallet/refund',
  BILLING_WALLET_TRANSACTIONS: '/admin/billing/wallet/transactions',
  BILLING_WALLET_MONTH_CREDITS: '/admin/billing/wallet/month-credits',
  BILLING_WALLET_PAY_INVOICES: '/admin/billing/wallet/pay-invoices',
  BILLING_WALLET_ADD_CREDIT: '/admin/billing/wallet/add-credit',
  BILLING_WALLET_CREDIT_REQUEST_CREATE: '/admin/billing/wallet/credit-requests/create',
  BILLING_WALLET_CREDIT_REQUEST_LIST: '/admin/billing/wallet/credit-requests/list',
  BILLING_WALLET_CREDIT_REQUEST_DECIDE: '/admin/billing/wallet/credit-requests/decide',
  BILLING_BILL_ADJUSTMENT_APPLY: '/admin/billing/bill-adjustment/apply',
  BILLING_BILL_ADJUSTMENT_REQUEST: '/admin/billing/bill-adjustment/request',
  BILLING_BILL_ADJUSTMENT_LIST: '/admin/billing/bill-adjustment/list',
  BILLING_BILL_ADJUSTMENT_DECIDE: '/admin/billing/bill-adjustment/decide',
  BILLING_WALLET_SETTLEMENT_LIST: '/admin/billing/wallet-settlement/list',
  BILLING_WALLET_SETTLEMENT_SET_AMOUNT: '/admin/billing/wallet-settlement/set-amount',
  BILLING_WALLET_SETTLEMENT_APPLY_DIFFERENCE: '/admin/billing/wallet-settlement/apply-difference',
  BILLING_WALLET_SETTLEMENT_PATIENT_MONTH: '/admin/billing/wallet-settlement/patient-month',
  BILLING_SERVICE_QUOTA_HISTORY: '/admin/billing/service-quota-history',
  BILLING_SETTLEMENT_PREVIEW: '/admin/billing/settlement/preview',
  BILLING_SETTLEMENT_GENERATE: '/admin/billing/settlement/generate',
  BILLING_INVOICES_GET: '/admin/billing/invoices/get',
  BILLING_INVOICES_LIST: '/admin/billing/invoices/list',
  BILLING_PATIENT_PREVIEW: '/admin/billing/patient-preview',

  // Data Export
  EXPORT_PATIENTS: '/admin/export/patients',
  EXPORT_STAFF: '/admin/export/staff',
  EXPORT_APPOINTMENTS: '/admin/export/appointments',
  EXPORT_SESSIONS: '/admin/export/sessions',
  EXPORT_BILLING: '/admin/export/billing',
  EXPORT_INCOME: '/admin/export/income',
  EXPORT_EXPENSES: '/admin/export/expenses',
  EXPORT_WAITING_LIST: '/admin/export/waiting-list',

  // Notifications
  NOTIFICATIONS_LIST: '/admin/notifications',
  NOTIFICATIONS_UNREAD_COUNT: '/admin/notifications/unread-count',
  NOTIFICATIONS_MARK_READ: '/admin/notifications/mark-read',
  NOTIFICATIONS_MARK_ALL_READ: '/admin/notifications/mark-all-read',
  NOTIFICATIONS_DELETE: '/admin/notifications/delete',
  NOTIFICATIONS_SMART_ALERTS: '/admin/notifications/smart-alerts',

  // CSV Attendance Import
  ATTENDANCE_IMPORT_CSV: '/admin/attendance/import-csv',
  ATTENDANCE_PREVIEW_CSV: '/admin/attendance/preview-csv',
  ATTENDANCE_DOWNLOAD_TEMPLATE: '/admin/attendance/download-template',

  // Payroll Management
  // Biometric Device Management
  BIOMETRIC_SUPPORTED_DEVICES: '/admin/biometric/supported-devices',
  BIOMETRIC_DEVICE_SAVE: '/admin/biometric/device/save',
  BIOMETRIC_DEVICE_LIST: '/admin/biometric/device/list',
  BIOMETRIC_DEVICE_DELETE: '/admin/biometric/device/delete',
  BIOMETRIC_DEVICE_TEST: '/admin/biometric/device/test',
  BIOMETRIC_DEVICE_SYNC: '/admin/biometric/device/sync',
  BIOMETRIC_DEVICE_FETCH_USERS: '/admin/biometric/device/fetch-users',
  BIOMETRIC_MAPPINGS_LIST: '/admin/biometric/mappings/list',
  BIOMETRIC_MAPPINGS_SAVE: '/admin/biometric/mappings/save',

  // Group Sessions
  GROUP_SESSION_SAVE: '/admin/group-session/save',
  GROUP_SESSION_LIST: '/admin/group-session/list',
  GROUP_SESSION_DETAILS: '/admin/group-session/details',
  GROUP_SESSION_AVAILABLE_PATIENTS: '/admin/group-session/available-patients',
  GROUP_SESSION_VALIDATE_CONFLICTS: '/admin/group-session/validate-conflicts',
  GROUP_SESSION_DELETE: '/admin/group-session/delete',
  GROUP_SESSION_TOGGLE: '/admin/group-session/toggle',
  GROUP_SESSION_ADD_PATIENT: '/admin/group-session/add-patient',
  GROUP_SESSION_REMOVE_PATIENT: '/admin/group-session/remove-patient',
  GROUP_SESSION_BOOK_PATIENT_PREVIEW: '/admin/group-session/book-patient/preview',
  GROUP_SESSION_BOOK_PATIENT: '/admin/group-session/book-patient',

  PAYROLL_SALARY_STRUCTURE_SAVE: '/admin/payroll/salary-structure/save',
  PAYROLL_SALARY_STRUCTURE_GET: '/admin/payroll/salary-structure/get',
  PAYROLL_GENERATE: '/admin/payroll/generate',
  PAYROLL_PREVIEW: '/admin/payroll/preview',
  PAYROLL_UPDATE: '/admin/payroll/update',
  PAYROLL_BULK_GENERATE: '/admin/payroll/bulk-generate',
  PAYROLL_UPDATE_STATUS: '/admin/payroll/update-status',
  PAYROLL_LIST: '/admin/payroll/list',
  PAYROLL_DETAILS: '/admin/payroll/details',
  PAYROLL_SUMMARY: '/admin/payroll/summary',
  PAYROLL_DELETE: '/admin/payroll/delete',
  PAYROLL_ADVANCE_SAVE: '/admin/payroll/advance/save',
  PAYROLL_ADVANCE_LIST: '/admin/payroll/advance/list',
  PAYROLL_STAFF_OVERVIEW: '/admin/payroll/staff-overview',

  HOLIDAY_LIST: '/admin/holidays/list',
  HOLIDAY_SAVE: '/admin/holidays/save',
  HOLIDAY_DEACTIVATE: '/admin/holidays/deactivate',

  // Leave Management (Step 7H)
  LEAVE_TYPES_LIST: '/admin/leave-types/list',
  LEAVE_TYPES_SAVE: '/admin/leave-types/save',
  LEAVE_TYPES_DEACTIVATE: '/admin/leave-types/deactivate',
  LEAVE_REQUESTS_SAVE: '/admin/leave-requests/save',
  LEAVE_REQUESTS_LIST: '/admin/leave-requests/list',
  LEAVE_REQUESTS_DETAILS: '/admin/leave-requests/details',
  LEAVE_REQUESTS_CANCEL: '/admin/leave-requests/cancel',
  LEAVE_REQUESTS_APPROVE: '/admin/leave-requests/approve',
  LEAVE_REQUESTS_REJECT: '/admin/leave-requests/reject',
  LEAVE_BALANCES_LIST: '/admin/leave-balances/list',
  LEAVE_BALANCES_SAVE: '/admin/leave-balances/save',
};
